import React, { useState, useEffect } from 'react';
//Bibliotecas
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
//Hooks
import { useForm } from 'react-hook-form';
import useAuth from '../../hooks/useAuth'
//Servicios
import AuthService from '../../services/AuthService'
//Componentes
import Form from '../../components/common/Form';
import Input from '../../components/common/Input';
import AvatarSelection from '../../components/common/AvatarSelection/AvatarSelection';
import RolSelection from './components/RolSelection';
import Button, { SecondaryButton } from '../../components/common/Button';
import Modal from '../../components/common/Modal';
import Error from '../../components/common/Error';
import FlexContainer from '../../components/common/FlexContainer';
//Imágenes
import { LogIn, UserCheck, User } from 'react-feather';



// Lógica de renderización de el input de selección de curso
function InputCurso({ rol, register, errors, handleToggleGuest, isGuest }) {
    if (rol === "estudiante") {
        return (
            <FlexContainer flexDirection='row' justifyContent='center' alignItems='center'>
                <Input
                    label='Código de curso'
                    name='codigoCurso'
                    placeholder="Ingresa el código de tu curso"
                    type='number'
                    register={register}
                    required={{ required: false }}
                    error={errors.codigoCurso}
                    isDisabled={isGuest}

                />
                <GuestButton>
                    <input type='checkbox' onChange={handleToggleGuest} checked={isGuest} id='guest-button'></input>
                    <label htmlFor='guest-button'>
                        {isGuest &&
                            <UserCheck></UserCheck>
                        }
                        {!isGuest &&
                            <User></User>
                        }
                        <span>Soy invitado</span>
                    </label>
                </GuestButton>
            </FlexContainer>
        )
    }
}



export default function Registro() {
    //Estados del formulario
    const [rol, setRol] = useState("");
    const [avatar, setAvatar] = useState("");
    const [modal, setModal] = useState(false);
    const [policyModal, setPolicyModal] = useState(false);
    const [error, setError] = useState("");
    const [isGuest, setIsGuest] = useState(false);
    const [loading, setLoading] = useState(false);
    //Estados de la petición
    const [registered, setRegistered] = useState(false);

    //React Hook Form
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    //Navigate
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from.pathname || "/home";

    //User context
    const { isLogged} = useAuth();

    //Manipuladores
    const handleToggleRadio = (e) => {
        setRol(e.target.value);
    }

    function handleAvatarSelection(a) {
        setAvatar(a);
    }

    function handleToggleModal() {
        setModal(!modal);
    }
    function handleTogglePolicyModal() {
        setPolicyModal(!policyModal);
    }

    const handleToggleGuest = (e) => {
        setIsGuest(e.target.checked);
    }

    //Navegar a la vista home cuando exita un usuario loggeado
    useEffect(() => {
        if (isLogged) {
            navigate(from, { replace: true });
        }
        setIsGuest(false);
    }, [isLogged, navigate])


    //Establecer datos de curso de invitados por default
    useEffect(() => {
        if (isGuest) {
            reset({ codigoCurso: 1111 });
        } else {
            reset({ codigoCurso: '' });
        }
    }, [reset, isGuest]);


    //Utilizar el servicio de registro al enviar formulario
    const onSubmit = (data) => {
        setLoading(true);
        AuthService.register({ data, rol, avatar })
            .then(() => {
                setRegistered(true);
                reset();
                setError("");
                setLoading(false);
            })
            .catch((error) => { setError(error.message); setLoading(false)});
    };

    //Se muestra un mensaje cuando el usuario se registra exitósamente
    if (registered) {
        return (
            <FlexContainer margin='2% 5%' width='35%' padding='32px 40px' borderRadius='10px' justifyContent='center'>
                <h1>Registro completo</h1>
                <h4>
                    Felicidades tu registro se ha completado exitosamente ✅
                </h4>
                <span>Para continuar, ¿qué deseas hacer?</span>
                <Button type='submit' margin='16px 0px' onClick={() => navigate('/')}><LogIn />Iniciar sesión</Button>
                <SecondaryButton type='submit' onClick={() => { setRegistered(false) }}>Registrarse</SecondaryButton>
            </FlexContainer>
        )
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)} margin='2% 5%' title='Registrarse' padding='32px 40px'>
            <Input
                label='Apellidos y nombre'
                name='nombre'
                placeholder="Ingresa primero tus apellidos y luego tu nombre"
                register={register}
                required={{ required: "Por favor ingresa tu nombre" }}
                error={errors.nombre} />

            <Input
                label='Correo electrónico'
                name='email'
                placeholder="Ingresa tu correo electrónico"
                register={register}
                required={{ required: "Por favor ingresa tu correo", pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Correo electrónico no válido" } }}
                error={errors.email} />

            <Input
                label='Contraseña'
                name='password'
                type='password'
                placeholder="Ingresa tu contraseña"
                register={register}
                required={{ required: "Por vafor ingresa tu contraseña", minLength: { value: 5, message: "La contraseña debe tener más de 5 caracteres" } }}
                error={errors.password} />

            <RolSelection handleToggleRadio={handleToggleRadio} register={register} error={errors.rol}></RolSelection>
            <InputCurso rol={rol} register={register} errors={errors} handleToggleGuest={handleToggleGuest} isGuest={isGuest} />
            <AvatarSelection handleAvatarSelection={handleAvatarSelection} />
            <p><small onClick={handleToggleModal}>Al registrarte aceptas los <a href='#'>términos y condiciones</a></small><small onClick={handleTogglePolicyModal}> y la <a href='#'>política de privacidad</a></small></p>

            <Button type='submit' margin='8px 0 24px 0' loading={loading}>Registrarse</Button>
            <Modal state={modal} setState={setModal} title="Términos y condiciones" textAlign={'left'}>
                <div>
                    <p><br />Bienvenido a APRENDETIC, propiedad de Johnatan Rodolfo Guerrero Guerrero, Cristian David Murcia Moreno y la Universidad de Cundinamarca.
                        <br /> <br />Al registrarse y utilizar este sitio web o cualquiera de sus páginas, usted expresa que entiende y acepta los términos y condiciones que se indican a continuación. En caso de no entender o aceptar los términos y condiciones, solicitamos que usted abandone el sitio inmediatamente.
                        <br /> <br />Nos reservamos el derecho a modificar, adicionar o remover cualquier parte de los presentes términos y condiciones. Avisando a los usuarios de la aplicación mediante una publicación en el sitio web o la difusión mediante correo electrónico. </p>
                    <Term>
                        <h5>1. Condiciones de registro, acceso y utilización </h5>
                        <p>Para hacer uso de este sitio o cualquiera de sus servicios el usuario debe ser mayor de 18 años, en caso de no serlo debe contar con la previa autorización de sus padres o tutores. Además, el usuario debe estar vinculado a la Institución Educativa Departamental Santa María del municipio de Ubaté.</p>
                    </Term>
                    <Term>
                        <h5>2. Requisitos para uso </h5>
                        <p>El usuario deberá contar con un computador que disponga de acceso a internet y sistema operativo Windows, garantizando que estos son seguros y confiables.  </p>
                    </Term>
                    <Term>
                        <h5>3. Propiedad Intelectual </h5>
                        <p>Todo el contenido disponible en el sitio, incluyendo textos, imágenes, videos y ejecuciones de Scratch son de libre acceso, reproducción y distribución. Para utilizar el contenido perteneciente a terceros el usuario deberá referenciar la fuente original de la información disponible al final de cada lección.
                            La propiedad intelectual del sitio web y cada una de sus páginas, incluyendo el diseño, código y funcionalidad pertenece a los propietarios, por lo tanto, no está permitida su reproducción, adaptación o distribución. </p>
                    </Term>
                    <Term>
                        <h5>4. Cancelación de cuenta </h5>
                        <p>En caso de que un usuario incumpla estos términos y condiciones o cualquier ley o regulación aplicable, los propietarios del sitio podrán suspender de manera temporal o permanente al acceso a sus servicios. </p>
                    </Term>
                    <Term>
                        <h5>5. Limitación de responsabilidad  </h5>
                        <p>En la máxima medida permitida por la ley aplicable, los propietarios no asumen responsabilidad alguna por errores o inexactitudes de contenido; lesiones personales o daños a la propiedad, de cualquier naturaleza que sean, como resultado de su acceso o uso del sitio; y cualquier acceso no autorizado o uso de nuestros servidores y / o toda la información personal almacenada en los mismos.</p>
                    </Term>
                </div>
            </Modal>
            <Modal state={policyModal} setState={setPolicyModal} title="Política de privacidad" textAlign={'left'}>
                <div>
                    <p><br />A continuación, se describe la “Política de privacidad” del sitio, donde se detalla cómo se recopila, protege, utiliza y comparte su información, también se informan los derechos y opciones que tiene sobre la misma. Al registrarse y utilizar este sitio o cualquiera de sus servicios usted entiende y acepta la “Política de privacidad”. </p>
                    <Term>
                        <h5>1. Información que recopilamos</h5>
                        <div>
                            <span><b>1.1 Información proporcionada</b></span>
                            <p>Cuando usted se registra, se recopilan los siguientes datos: nombres, apellidos y correo electrónico. </p>
                        </div>
                        <div>
                            <span><b>1.2 Datos de actividad </b></span>
                            <p>Cuando utiliza los servicios del sitio recopilamos información relacionada al proceso de 	aprendizaje, como las páginas que visita, las actividades completadas y el número de pistas 	solicitadas en dichas actividades. </p>
                        </div>
                    </Term>
                    <Term>
                        <h5>2. Como protegemos la información </h5>
                        <p>Este sitio implementa las medidas de seguridad técnicas que considera necesarias para mantener la confidencialidad, integridad y disponibilidad de la información. Sin embargo, no es posible garantizar que el sistema de seguridad sea impenetrable, por lo que un atacante con los recursos necesarios podría interceptar dicha información.</p>
                    </Term>
                    <Term>
                        <h5>3. Como utilizamos la información</h5>
                        <p>Utilizamos información para procesos internos relacionados con los servicios que ofrece el sitio. También para la generación de datos estadísticos que permitan evaluar el progreso y desempeño en la actividad de aprendizaje de los usuarios con rol de estudiante, lo anterior con fines investigativos.  </p>
                    </Term>
                    <Term>
                        <h5>4. ¿La información es compartida con alguien? </h5>
                        <p>Se comparte información con proveedores externos de servicios de infraestructura, alojamiento web, análisis de datos y correos transaccionales. </p>
                    </Term>
                    <Term>
                        <h5>5. Cookies </h5>
                        <p>El sitio almacena información del navegador haciendo uso de “cookies”, cuando se visitan páginas que incluyen un contexto de navegación anidado como los son los videos de “youtube.com” o las ejecuciones de “scratch.mit.edu”. Las cookies son archivos de texto que se almacenan en el disco duro de su computadora y se utilizan para reconocer su navegador y su sesión de navegación.
                        <br/><br/>Además, se guardan datos en el almacenamiento de la sesión, como el tiempo que ha permanecido en la plataforma y el token de autenticación. Estos fragmentos de datos se destruyen automáticamente cuando usted cierra la pestaña del navegador o cierra el navegador.
                        </p>
                    </Term>
                    <Term>
                        <h5>6. Sus derechos y opciones </h5>
                        <p>Puede cambiar la configuración de la cuenta en el momento que lo requiera, para modificar o 	actualizar su información. Además, podrá reestablecer la contraseña a partir de su correo 	electrónico y eliminar su cuenta de forma permanente.
                        </p>
                    </Term>
                    <Term>
                        <h5>7. Contáctenos </h5>
                        <p>Correo electrónico:  aprendetic01@gmail.com </p>
                    </Term>
                </div>
            </Modal>
            <Error message={error}></Error>
            <span>¿Ya tienes una cuenta? <NavLink to='/'>Iniciar sesión</NavLink></span>
        </Form>

    )
}



const GuestButton = styled.div`
    margin-left:24px;
    align-self:end;

    input{
        display: none;
        &:checked+label {
        background-color: var(--color-rosa);
        color: var(--color-blanco);
        }
    }

    label{
        box-sizing:border-box;
        cursor: pointer;
        height:100%;
        width:100%;
        border:2px solid var(--color-rosa);
        border-radius:5px;
        display:flex;
        flex-direction:row;
        justify-content: flex-end;
        align-items:center;
        transition: 0.4s all;
        padding:16px 8px;

        svg{
            margin-right:8px;
            width:32px;
        }
        span{
            width:100px;
        }
    }
`;
const Term = styled.div`
    margin-top:24px;
    h5{
        margin-bottom:8px;
        color:var(--color-morado-oscuro);
    }
    div{
        margin-left:32px;
        margin-bottom:16px;
    }
`;

